"use client";

import React from "react";
import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";

export default function LoginClient() {
  const sp = useSearchParams();
  const callbackUrl = sp?.get("callbackUrl") || "/";

  return (
    <main style={{ padding: 18, maxWidth: 680, margin: "0 auto" }}>
      <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800 }}>Sign in</h1>
      <p style={{ color: "#374151" }}>You must sign in to use OctaveConnect.</p>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 14 }}>
        <button onClick={() => signIn("google", { callbackUrl })} style={btnDark}>
          Continue with Google
        </button>
        <button onClick={() => signIn("apple", { callbackUrl })} style={btnLight}>
          Continue with Apple
        </button>
      </div>
    </main>
  );
}

const btnDark: React.CSSProperties = {
  padding: "10px 14px",
  borderRadius: 10,
  border: "1px solid #d1d5db",
  background: "#111827",
  color: "white",
  cursor: "pointer",
};

const btnLight: React.CSSProperties = {
  padding: "10px 14px",
  borderRadius: 10,
  border: "1px solid #d1d5db",
  background: "#f3f4f6",
  color: "#111827",
  cursor: "pointer",
};
